const STORAGE_PREFIX = 'disasterms:institution-sidebar';

const normalizedIdentifier = (value, fallback) => {
  const normalized = String(value || '').trim();
  return normalized || fallback;
};

export const institutionSidebarPreferenceKey = (user) => {
  const userId = normalizedIdentifier(
    user?.id || user?._id || user?.email,
    'anonymous'
  );
  const institutionId = normalizedIdentifier(
    user?.saas_context?.institution_id
      || user?.institution_id
      || user?.organization_id,
    'legacy'
  );

  return `${STORAGE_PREFIX}:${institutionId}:${userId}`;
};

export const readInstitutionSidebarPreference = (user) => {
  if (typeof window === 'undefined') return null;

  try {
    const value = window.localStorage.getItem(institutionSidebarPreferenceKey(user));
    if (value === 'collapsed') return true;
    if (value === 'expanded') return false;
  } catch (_) {
    // Storage can be unavailable in privacy-restricted browser contexts.
  }

  return null;
};

export const writeInstitutionSidebarPreference = (user, isCollapsed) => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(
      institutionSidebarPreferenceKey(user),
      isCollapsed ? 'collapsed' : 'expanded'
    );
  } catch (_) {
    // The sidebar still works through Redux when persistence is unavailable.
  }
};
